import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../components/Home/Home';
import ToolPage from '../components/Tools/ToolPage';
import About from '../components/Pages/About';
import Contact from '../components/Pages/Contact';
import Login from '../components/Admin/Login/Login';
import AdminLayout from '../components/Admin/Layout/AdminLayout';
import BlogManager from '../components/Admin/Blog/BlogManager';
import ProtectedRoute from '../components/Admin/ProtectedRoute';
import { TOOL_SLUGS } from '../data/toolSlugs';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<Navigate replace to="/" />} />
      <Route path="/blog/:id" element={<Navigate replace to="/" />} />
      <Route path="/admin/login" element={<Login />} />
      <Route
        path="/admin/blog"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <BlogManager />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      {/* Canonical (SEO) tool pages */}
      {TOOL_SLUGS.map((t) => (
        <Route key={t.seoPath} path={t.seoPath} element={<ToolPage />} />
      ))}

      {/* Legacy tool pages -> redirect to canonical slugs */}
      {TOOL_SLUGS.map((t) => (
        <Route
          key={t.legacyPath}
          path={t.legacyPath}
          element={<Navigate replace to={t.seoPath} />}
        />
      ))}
    </Routes>
  );
};

export default AppRoutes;

